import Pinyin from './jian_pinyin.js'

export function pySegSort(arr) {
  arr.forEach(item => {
    item.pinyin = (getInitial(item.name) || '').toLocaleUpperCase()
  })

  let res = {}
  let segs = []

  let letters = "*ABCDEFGHIJKLNMOPQRSTUVWXYZ".split("")
  let pattern = new RegExp("[`\\-~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？12345678990]") //特殊符号

  letters.filter((items, i) => {
    let curr = {
      initial: '', //字母
      data: [],  //数据
    };
    arr.map((v) => {
      // 特殊字符
      if (pattern.test(v.pinyin[0]) && i === 0) {
        curr.data.push(v)
      } else {
        if (v.pinyin[0] === items) {
          curr.data.push(v)
        }
      }
      if (curr.data.length) {
        curr.initial = letters[i]
        segs.push(curr);
        curr.data.sort((a, b) => {
          return a.pinyin - b.pinyin
        });
      }
    })
  })
  res.segs = Array.from(new Set(segs)) //去重
  return res;
}

function getInitial(str) {
  let pinyin = Pinyin.getSpell(str, function (charactor, spell) {
    return spell[0];
  })
  return pinyin.split(',').join('')
}

export function pySegSortIOS(arr) {
  if (arr.length == 0) return;
  if (!String.prototype.localeCompare) return null;
  var letters = "*ABCDEFGHJKLMNOPQRSTWXYZ".split("");
  var zh = "阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀".split("");
  var segs = []; // 存放数据
  var res = {};
  let curr;
  var re = /[^\u4e00-\u9fa5]/;//中文正则
  var pattern = new RegExp("[`\\-~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？12345678990]"); //特殊符号

  letters.filter((items, i) => {
    curr = {
      initial: '', //字母
      data: [],  //数据
    };
    arr.map((v) => {
      // 特殊字符
      if (pattern.test(v.name[0])) {
        if ((!zh[i - 1] || zh[i - 1].localeCompare(v.name) <= 0) && v.name.localeCompare(zh[i]) == -1) {
          curr.data.push(v);
        }
      }
      // 判断首个字是否是中文 
      if (re.test(v.name[0])) {
        // 英文 
        if (v.name[0].toUpperCase() == items) {
          curr.data.push(v);
        }
      } else {
        // 中文
        if ((!zh[i - 1] || zh[i - 1].localeCompare(v.name) <= 0) && v.name.localeCompare(zh[i]) == -1) {
          curr.data.push(v);
        }
      }

    })

    if (curr.data.length) {
      curr.initial = letters[i]
      segs.push(curr);
      curr.data.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }
  })
  res.segs = Array.from(new Set(segs)) //去重
  return res;
}
